import { AppRouteRecordRaw } from '../types';

const Body = () => import('@/components/body.vue');
const OrderLookupGettingStarted = () =>
  import('@/pages/partner/order-lookup/getting-started/OrderLookupGettingStarted.vue');
const OrderLookupApiReference = () =>
  import('@/pages/partner/order-lookup/api-reference/OrderLookupApiReference.vue');

export const orderLookupRoutes: AppRouteRecordRaw[] = [
  {
    path: '/order-lookup',
    component: Body,
    meta: {
      requiresAuth: true,
      requiredUserGroup: ['ryd', 'oilpay', 'allguth'],
      breadcrumb: 'Order Lookup',
    },
    children: [
      {
        path: 'getting-started',
        name: 'OrderLookupGettingStarted',
        component: OrderLookupGettingStarted,
        meta: {
          title: 'Order Lookup - Getting Started',
          requiresAuth: true,
          breadcrumb: 'Getting Started',
        },
      },
      {
        path: 'api-reference',
        name: 'OrderLookupApiReference',
        component: OrderLookupApiReference,
        meta: {
          title: 'Order Lookup API Reference | ryd Portal',
          requiresAuth: true,
          breadcrumb: 'API Reference',
        },
      },
    ],
  },
];
